import { type LocalStorageKey } from '@lib/browsers/localStorage/LocalStorageItem'

export const autoCompleteLocalStorageKey =
  'trialAutoCompleteValues' as LocalStorageKey

export type AutoCompleteValues = {
  name?: string
  phone?: string
  zipcode?: string
}
